import { CONFIG } from '../../Config/config'

const { appID, secretKey } = CONFIG.TALKJS

const getUserTalkJs = async userId => {
  const response = await fetch(
    `https://api.talkjs.com/v1/${appID}/users/${userId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
    },
  )
  const result = await response.json()
  return result
}

const sendMessageTalkJs = async ({ conversationId, body }) => {
  const response = await fetch(
    `https://api.talkjs.com/v1/${appID}/conversations/${conversationId}/messages`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
      body: JSON.stringify(body),
    },
  )
  const result = await response.json()
  return result
}

const getTalkJsConversations = async ({
  conversationId,
  filter = {},
  userId,
  startingAfter,
}) => {
  const { cityId, countryId } = filter

  const dynamicFilter = {
    custom: {
      [countryId ? 'countryId' : 'cityId']: [
        '==',
        String(countryId ? countryId : cityId),
      ],
    },
  }

  const encodedFilter = encodeURIComponent(JSON.stringify(dynamicFilter))

  const url = conversationId
    ? `https://api.talkjs.com/v1/${appID}/conversations/${conversationId}`
    : `https://api.talkjs.com/v1/${appID}/conversations?filter=${encodedFilter}`

  const formattedUrl = userId
    ? `https://api.talkjs.com/v1/${appID}/users/${userId}/conversations${
        startingAfter ? `?startingAfter=${startingAfter}` : ''
      }`
    : url

  try {
    const response = await fetch(formattedUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
    })
    return await response.json()
  } catch (error) {
    return { data: [] }
  }
}

export const getUnreadCount = async ({ userId }) => {
  const url = `https://api.talkjs.com/v1/${appID}/users/${userId}/conversations?unreadsOnly=true&limit=1`
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${secretKey}`,
    },
  })

  const { data } = await response.json()

  return data.length
}

export const getAllUserConversations = async ({ startingAfter, userId }) => {
  const { data: conversations } = await getTalkJsConversations({
    userId: userId,
    startingAfter,
  })
  let allConversations = conversations
  const lastFetchedConversationCount = conversations.length

  if (lastFetchedConversationCount > 0) {
    const conversations = await getAllUserConversations({
      startingAfter: `${allConversations[allConversations.length - 1].id}`,
      userId,
    })
    if (conversations) {
      allConversations = [...allConversations, ...conversations]
    }
  }
  return allConversations
}
const createConversationTalkJs = async ({ conversationId, ...payload }) => {
  const existingConversationData = await getTalkJsConversations({
    conversationId,
  })
  if (existingConversationData && existingConversationData.createdAt) {
    return 'Already created'
  }

  const response = await fetch(
    `https://api.talkjs.com/v1/${appID}/conversations/${conversationId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
      body: JSON.stringify(payload),
    },
  )
  const result = await response.json()
  return result
}

const createUpdateTalkJsUser = async user => {
  const formattedUserData = {
    id: user.id,
    name: `${user.firstName} ${user.lastName}`,
    role: user.role,
    photoUrl: user.profilePicture,
  }
  const response = await fetch(
    `https://api.talkjs.com/v1/${appID}/users/${user.id}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
      body: JSON.stringify(formattedUserData),
    },
  )
  return await response.json()
}

const joinToConversation = async ({
  conversationId,
  userId,
  params = { access: 'ReadWrite', notify: false },
}) => {
  const response = await fetch(
    `https://api.talkjs.com/v1/${appID}/conversations/${conversationId}/participants/${userId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${secretKey}`,
      },
      body: JSON.stringify(params),
    },
  )
  return await response.json()
}

const getUnreadStatuses = async userId => {
  return {
    hasUnreadChats: false,
    hasUnreadReport: false,
  }
  // const chatsFilter = { category: ['oneOf', ['support', 'group']] }
  // const chatsFilterWithCustomCategory = {
  //   custom: { category: ['oneOf', ['support', 'group']] },
  // }
  // const missionReportFilter = {
  //   custom: { spyLink: 'exists' },
  // }
  // const encodedChatsFilter = encodeURIComponent(JSON.stringify(chatsFilter))
  // const getChatConversationsUrl = `https://api.talkjs.com/v1/${appID}/users/${userId}/conversations?filter=${encodedChatsFilter}&limit=10&unreadsOnly=true`

  // const encodedChatsFilterWithCustomCategory = encodeURIComponent(
  //   JSON.stringify(chatsFilterWithCustomCategory),
  // )
  // const getChatWithCustomCategoryConversationsUrl = `https://api.talkjs.com/v1/${appID}/users/${userId}/conversations?filter=${encodedChatsFilterWithCustomCategory}&limit=10&unreadsOnly=true`

  // const encodedReportFilter = encodeURIComponent(
  //   JSON.stringify(missionReportFilter),
  // )
  // const getReportConversationsUrl = `https://api.talkjs.com/v1/${appID}/users/${userId}/conversations?filter=${encodedReportFilter}&limit=10&unreadsOnly=true`

  // const chatResponse = await fetch(getChatConversationsUrl, {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${secretKey}`,
  //   },
  // })

  // const withCustomCategory = await fetch(
  //   getChatWithCustomCategoryConversationsUrl,
  //   {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${secretKey}`,
  //     },
  //   },
  // )

  // const reportResponse = await fetch(getReportConversationsUrl, {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json',
  //     'Authorization': `Bearer ${secretKey}`,
  //   },
  // })

  // const chatResult = await chatResponse.json()
  // const chatWithCustomCategoryResult = await withCustomCategory.json()
  // const reportResult = await reportResponse.json()

  // const chatConversations = chatResult.data
  // const chatWithCustom = chatWithCustomCategoryResult.data
  // const reportConversations = reportResult.data

  // const allChats = [
  //   ...chatConversations,
  //   ...chatWithCustom,
  //   ...reportConversations,
  // ]
  // const uniqueChats = allChats.reduce((acc, chat) => {
  //   acc[chat.id] = chat
  //   return acc
  // }, {})

  // const { chatLength, reportLength } = Object.values(uniqueChats).reduce(
  //   (acc, chat) => {
  //     const type = chat.id.split(':')[0]
  //     if (type == 'support' || type == 'group') {
  //       acc.chatLength += 1
  //     }
  //     if (type == 'missionReport') {
  //       acc.reportLength += 1
  //     }
  //     return acc
  //   },
  //   { chatLength: 0, reportLength: 0 },
  // )
  // return {
  //   hasUnreadChats: chatLength > 0,
  //   hasUnreadReport: reportLength > 0,
  // }
}

export {
  getUnreadStatuses,
  getUserTalkJs,
  createConversationTalkJs,
  sendMessageTalkJs,
  createUpdateTalkJsUser,
  getTalkJsConversations,
  joinToConversation,
}
